import { History } from 'history'

/**
 * Returns to the previous page after add/edit and tags the return location with `state.reload` so the
 * dossier party overview refetches (HAM-3838 / HAM-4001). The overview listens for that flag; the
 * global `/party` overview refreshes on remount. Kept identical to the legacy pages on purpose.
 */
export const partyGoBack = (history: History) => (): void => {
    history.goBack()
    setTimeout(() => {
        history.replace({ ...history.location, state: { reload: true } })
    }, 10)
}
